<div class="row">
  <div class="col">
    @if (largeHeader()) {
      @if (header()) {
        <h2 class="header-top">
          {{ header() }}
        </h2>
      }
    } @else {
      @if (header()) {
        <div class="header-top">
          {{ header() }}
        </div>
      }
    }

    <a (click)="openPreview()">
      @if (imageSource && image()) {
        <figure class="figure">
          <img [height]="height()" [width]="width()" [attr.src]="imageSource" class="figure-img img-fluid rounded" alt="" />
        </figure>
      }
    </a>
  </div>
</div>

<div class="row mt-3">
  <div class="col d-flex">
    @if (showPreview() && showUpload && file.src) {
      <button class="btn btn-primary btn-sm" (click)="onUpload()">
        <i class="fa fa-file-upload"></i>&nbsp;<span i18n>Upload</span>
      </button>
    }
    @if (showBrowse()) {
      <button class="btn btn-primary btn-sm" (click)="input.click()">
        <input type="file" (change)="fileChange(input)" #input hidden />
        <i class="fa fa-folder-open"></i>&nbsp;{{ browseButtonText() }}
      </button>
    }
    @if (imageSource && showRemove()) {
      <button class="btn btn-danger btn-sm" (click)="onRemove()">
        <span i18n>Remove</span>
      </button>
    }
  </div>
</div>
